var plugin_default = {
  "alignLeft": "fRYGM",
  "textWrapNowrap": "T23AI",
  "alignRight": "_22nXo",
  "alignCenter": "O7onT",
  "sizeFullWidth": "_7HeLf",
  "renderedInTable": "TY6ea",
  "sizeOriginal": "NtNDg",
  "sizeContent": "RRTT-",
  "sizeSmall": "MHufh",
  "sizeSmallCenter": "So8Cv",
  "flex": "tryeJ",
  "atomic": "_9ecFQ",
  "embed": "NP-w-",
  "horizontalScrollbar": "O1TH6",
  "pluginContainerMobile": "aWZm-"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
